var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHeartDarkW13 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M7.66 1.962a2.999 2.999 0 0 1 3.27 4.892l-4.43 4.43-4.43-4.43a3 3 0 0 1 4.242-4.242L6.5 2.8l.188-.188a3 3 0 0 1 .973-.65M8.81 2.6a2.13 2.13 0 0 0-1.508.625l-.801.8-.801-.8a2.133 2.133 0 0 0-3.016 3.016L6.5 10.058l3.817-3.817a2.132 2.132 0 0 0-1.508-3.64",
  clipRule: "evenodd"
})));
export default SvgIconHeartDarkW13;